import React, { FunctionComponent } from 'react';
import { Card, ListGroup } from 'react-bootstrap';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { IAppState } from '../../common/models/store/IAppState';
import { logout } from '../../services/authService';
import Icon from '../../components/Icon';
import { RoleType } from '../../common/enums/RoleType';
import { Routes } from '../../common/enums/Routes';
import { IPopoverChild } from '../../common/models/common/IPopoverChild';
import { User } from '../../common/models/user/User';
import styles from './styles.module.scss';

interface IProfileMenuProps extends IPopoverChild {
  user: User;
  workspaceName: string;
}

const ProfileMenu: FunctionComponent<IProfileMenuProps> = ({ user, workspaceName, hidePopover = () => null }) => {
  const { firstName, lastName, email, role } = user;

  return (
    <Card bsPrefix={styles.card}>
      <ListGroup className="list-group-flush">
        <div className={styles.header}>
          <div className={styles.name}>{`${firstName} ${lastName}`}</div>
          <div className="mb-2">{workspaceName}</div>
          <div>{email}</div>
        </div>
        <div>
          <NavLink onClick={hidePopover} className={styles.actionsItem} to={Routes.ProfileSettings}>
            <Icon icon="user" />
            <FormattedMessage id="profileMenu.profile" defaultMessage="My profile" />
          </NavLink>
          <NavLink onClick={hidePopover} className={styles.actionsItem} to={Routes.NotificationsSettings}>
            <Icon icon="bell" />
            <FormattedMessage id="profileMenu.notifications" defaultMessage="Notification preferences" />
          </NavLink>
          <NavLink onClick={hidePopover} className={styles.actionsItem} to={Routes.MessagesSettings}>
            <Icon icon="messageBubbleSecond" />
            <FormattedMessage id="profileMenu.messages" defaultMessage="Message templates" />
          </NavLink>
          {role !== RoleType.User && (
            <NavLink onClick={hidePopover} className={styles.actionsItem} to={Routes.UsersSettings}>
              <Icon icon="candidates" />
              <FormattedMessage id="profileMenu.users" defaultMessage="Manage users & teams" />
            </NavLink>
          )}
          {role === RoleType.SuperAdmin && (
            <NavLink onClick={hidePopover} className={styles.actionsItem} to={Routes.CandidateFormSettings}>
              <Icon icon="preview" />
              <FormattedMessage id="profileMenu.candidateForm" defaultMessage="Candidate form preview" />
            </NavLink>
          )}
          <div
            role="presentation"
            onClick={() => {
              window.Beacon('open');
              hidePopover();
            }}
            className={`${styles.actionsItem} ${styles.helpItem}`}
          >
            <Icon icon="questionCircle" />
            <FormattedMessage id="profileMenu.help" defaultMessage="Help / support" />
          </div>
          <div className={`${styles.actionsItem} ${styles.logoutItem}`} role="presentation" onClick={logout}>
            <Icon className={styles.logoutIcon} icon="download" />
            <FormattedMessage id="profileMenu.logout" defaultMessage="Log out" />
          </div>
        </div>
      </ListGroup>
    </Card>
  );
};

const mapStateToProps = ({
  user: { user },
  workspace: { name }
}: IAppState) => ({ user: user as User, workspaceName: name });

export default connect(mapStateToProps)(ProfileMenu);
